import { useMutation } from "@tanstack/react-query";
import type { RequestState } from "@/types";
import type { Message } from "../api/message";
import { sendMessage } from "../api/message";

export interface UseMessageResult {
	messageRequest: RequestState<void>;
	sendMessage: (data: Message) => Promise<void>;
	reset: () => void;
}

export const useMessage = (): UseMessageResult => {
	const mutation = useMutation({
		mutationFn: sendMessage,
	});

	const messageRequest: RequestState<void> = {
		status: mutation.status === "pending" ? "loading" : mutation.status,
		...(mutation.status === "success" ? { data: undefined } : {}),
		...(mutation.status === "error"
			? {
					message:
						mutation.error instanceof Error
							? mutation.error.message
							: "An unknown error occurred.",
				}
			: {}),
	} as RequestState<void>;

	return {
		messageRequest,
		sendMessage: mutation.mutateAsync,
		reset: mutation.reset,
	};
};
